module.exports = __webpack_public_path__ + "static/India-Retail-e-retail-awards-2019-42cd2838935822930408ee6c3c60cf0b.png";